/**
 * Constantes de la aplicación
 */

// Roles de usuario
export const USER_ROLES = {
  ADMIN: 'ADMIN',
  DIRECTOR: 'DIRECTOR',
  VENDEDOR: 'VENDEDOR',
  CONTADOR: 'CONTADOR',
  AUDITOR: 'AUDITOR',
};

// Labels de roles
export const ROLE_LABELS = {
  [USER_ROLES.ADMIN]: 'Administrador',
  [USER_ROLES.DIRECTOR]: 'Director Técnico',
  [USER_ROLES.VENDEDOR]: 'Vendedor',
  [USER_ROLES.CONTADOR]: 'Contador',
  [USER_ROLES.AUDITOR]: 'Auditor',
};

// Colores para gráficos
export const CHART_COLORS = {
  primary: '#4F46E5',
  secondary: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
  success: '#22C55E',
};

// Formatos de fecha
export const DATE_FORMATS = {
  short: 'DD/MM/YYYY',
  long: 'DD/MM/YYYY HH:mm',
  time: 'HH:mm',
  monthYear: 'MMMM YYYY',
};

// Mensajes de error comunes
export const ERROR_MESSAGES = {
  network: 'Error de conexión. Verifica tu conexión a internet.',
  unauthorized: 'No tienes permisos para realizar esta acción.',
  notFound: 'El recurso solicitado no fue encontrado.',
  serverError: 'Error del servidor. Intenta nuevamente más tarde.',
  timeout: 'La petición ha excedido el tiempo de espera.',
  invalidCredentials: 'Usuario o contraseña incorrectos.',
  sessionExpired: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.',
};

// Mensajes de éxito
export const SUCCESS_MESSAGES = {
  login: 'Inicio de sesión exitoso',
  logout: 'Sesión cerrada correctamente',
  save: 'Guardado exitosamente',
  update: 'Actualizado exitosamente',
  delete: 'Eliminado exitosamente',
  create: 'Creado exitosamente',
};

// Estados de carga
export const LOADING_STATES = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

// Tamaños de paginación
export const PAGE_SIZES = [10, 20, 50, 100];

// Intervalo de actualización del dashboard (5 minutos)
export const DASHBOARD_REFRESH_INTERVAL = 300000;

// Formato de moneda
export const CURRENCY_FORMAT = {
  style: 'currency',
  currency: 'CLP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

// Formato de número
export const NUMBER_FORMAT = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

const constants = {
  USER_ROLES,
  ROLE_LABELS,
  CHART_COLORS,
  DATE_FORMATS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  LOADING_STATES,
  PAGE_SIZES,
  DASHBOARD_REFRESH_INTERVAL,
  CURRENCY_FORMAT,
  NUMBER_FORMAT,
};

export default constants;

// Made with Bob
